import { getTranslations } from '@utils/server/getTranslations';

const i18n = {
  locales: [
    'en-US',
    'de-DE',
    'da-DK',
    'fr-FR',
    'en-CA',
    'fr-CA',
    'en-GB',
    'en-AU',
    'en-NZ',
    'es-ES',
    'it-IT',
    'sv-SE',
    'no-NO',
    'fi-FI',
    'nl-NL',
    'en-ZA',
  ],
  defaultLocale: 'en-US',
  defaultNS: 'common',
  namespaces: ['common'],
  loadLocaleFrom: getTranslations,
};
export default i18n;
